import { toast, ToastOptions, Id } from "react-toastify";
import { ToastDS, ToastType } from "./Toast";

export const triggerToastDS = (
  text: string,
  type: ToastType,
  options?: ToastOptions,
): Id | undefined => {
  if (type === "SUCCESS")
    return toast.success(<ToastDS text={text} type="SUCCESS" />, options);
  if (type === "ERROR")
    return toast.error(<ToastDS text={text} type="ERROR" />, options);
  if (type === "DOWNLOADING")
    return toast.info(<ToastDS text={text} type="DOWNLOADING" />, options);
  return undefined;
};

export const dismissToastDS = (toastId?: Id) => {
  toast.dismiss(toastId);
};
